import {create} from "zustand";
// import {CatalogDrawerFilter} from "./types";

type CatalogFilterDrawerStore = {
    opened: boolean;
    filterKey: string | null;
    // filter: CatalogDrawerFilter | null;
    actions: {
        openModal: (filterKey: string) => void;
        // openModal: (filter: CatalogDrawerFilter) => void;
        closeModal: () => void;
    }
};
export const useCatalogFilterDrawer = create<CatalogFilterDrawerStore>((set) => ({
    opened: false,
    filterKey: null,
    // filter: null,
    actions: {
        openModal: (filterKey) => set({opened: true, filterKey}),
        // openModal: (filter) => set({opened: true, filter}),
        closeModal: () => set({opened: false, filterKey: null}),
    },
}));
